import { render } from "./CheckTicket.vue?vue&type=template&id=37be0940"
import script from "./CheckTicket.vue?vue&type=script&lang=js"
export * from "./CheckTicket.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__